import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cm_action from 'actions/commons';
import * as booking_action from 'actions/booking';
import { BookingStatsForm, BookingStatsResult } from 'components/BookingStats';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul'); // 서버시간과 다를경우를 대비하여 설정함
import cm from 'helpers/commons';
import storage from 'helpers/storage';

class BookingStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initDate: moment().startOf('day'),
      initDateType: 'MM'
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);
  }

  componentDidMount() {
    cm.mainTitle('예약 통계');
    let comInfo = (storage.get('company') || {}).info;
    if (!(comInfo || {}).isBooking) {
      this.context.router.history.push('/service/landing');
      return <div></div>;
    }
    //가맹점 목록
    this.storeSearch();

    // 예약 통계
    this.bookingStatsSel();
  }

  //가맹점
  storeSearch = async () => {
    try {
      const { cmAPI } = this.props;
      const params = {
        filter: 'BOOKING'
      };

      await cmAPI.storeList(params);
    } catch (e) {
      console.log('##### storeSearch : ', e);
    }
  };

  // 예약 통계 목록
  bookingStatsSel = () => {
    const { initDate, initDateType } = this.state;
    const { bookingAPI, date, dateType, store } = this.props;
    const params = {
      start: date ? moment(date.sDate).format('YYYY-MM-DD') : `${initDate.format('YYYY-MM')}-01`,
      end: date ? moment(date.eDate).format('YYYY-MM-DD') : initDate.format('YYYY-MM-DD'),
      datetype: dateType ? dateType.value : initDateType,
      storeId: store ? store.value : null
    };

    bookingAPI.bookingStatsSel(params);

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: {
        startdate: params.start,
        enddate: params.end,
        datetype: params.datetype,
        storeid: params.storeId
      }
    });
  };

  // 조회 버튼 클릭 후 예약 통계 리스트 재호출
  submitForm = (e) => {
    this.bookingStatsSel();
  };

  render() {
    const { statsSel } = this.props;
    let statsList = null;

    if (statsSel) {
      const { data } = statsSel;

      statsList = data;
    }

    return (
      <Fragment>
        <BookingStatsForm submitForm={this.submitForm} />
        <BookingStatsResult data={statsList} />
      </Fragment>
    );
  }
}

BookingStats.contextTypes = {
  router: PropTypes.object.isRequired
};

BookingStats = connect(
  (state) => ({
    statsSel: state.booking.bookingStatsSel,

    dateCheck: state.commons.dateCheck,
    dateType: state.commons.dateType,
    date: state.commons.date,
    store: state.commons.store
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        storeList: cm_action.StoreList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),

    bookingAPI: bindActionCreators(
      {
        bookingStatsSel: booking_action.BookingStatsSel
      },
      dispatch
    )
  })
)(BookingStats);

export default BookingStats;
